<script>
    import Datepicker from 'vuejs-datepicker';
    import Timepicker from './Timepicker';
    import {it} from 'vuejs-datepicker/dist/locale';

    export default {
        components: {
            'datepicker': Datepicker,
            'timepicker': Timepicker
        },
        name: "StepSix",
        props: {
            'course': Object,
            'lesson': Object
        },
        data() {
            return {
                lesson_date: null,
                it: it,
                loading: false,
                lessonDurationOptions: [
                    {
                        text: 'Durante tutte le ore di lezione, su prenotazione',
                        value: true
                    },
                    {
                        text: 'Solo in una data/ora specifica (es. il giorno delle lezioni aperte)',
                        value: false
                    }
                ],
                lessonPriceOptions: [
                    {
                        text: 'Prima lezione gratuita',
                        value: true
                    },
                    {
                        text: 'Prima lezione €',
                        value: false
                    }
                ],
                validationErrors: {
                    dateTimeError: false,
                    priceError: false,
                    equipmentError: false
                },
            }
        },
        mounted() {
            var self = this;

            if (this.lesson.specificDate.date) {
                this.lesson.specificDate.date = moment(this.lesson.specificDate.date).format('YYYY-MM-DD');
                this.lesson_date = this.lesson.specificDate.date
            }
        },
        methods: {
            onDateSelected(date) {
                let current = moment(date)
                this.$set(this.lesson.specificDate, 'date', current.format('YYYY-MM-DD'))
            },
            includeTrialFee(course) {
                course.trial_with_membership_fee  = true;
            },
            excludeTrialFee(course) {
                course.trial_with_membership_fee = false;
            },
            calculateTotal(lesson) {
                if (this.course.trial_with_membership_fee) {
                    if (lesson.price) {
                        return parseInt(this.course.membership_fee) + parseInt(lesson.price);
                    } else {
                        return 0;
                    }
                } else {
                    if (lesson.price) {
                        return parseInt(lesson.price);
                    } else {
                        return 0;
                    }
                }
            },
            previousStep() {
                this.$emit('update-step', 4, 5);
            },
            isLoading() {
                return this.loading;
            },
            postForm() {
                var self = this;

                this.loading = true;
                this.$bus.$emit('searching');

                axios({
                    method: 'put',
                    url: '/courses/' + this.course.courseId + '/lesson',
                    data: {
                        lesson: this.lesson,
                        course: this.course
                    },
                }).then((response) => {
                    this.loading = false;
                    this.$bus.$emit('filtered');
                    this.$bus.$emit('update-membership_fee', self.course.membership_fee);
                    this.$emit('update-step', 6, 5);
                }).catch((error) => {
                    this.loading = false;
                    this.$bus.$emit('filtered');
                    this.message = 'Error';
                });
            },
            validation() {
                this.validationErrors.dateTimeError = false;
                this.validationErrors.priceError = false;
                this.validationErrors.equipmentError = false;

                if (!this.lesson.isDuringCourseTime) {
                    if (!this.lesson.specificDate.date || this.lesson.specificDate.time.hours < 0 || this.lesson.specificDate.time.hours > 23 || this.lesson.specificDate.time.minutes < 0 || this.lesson.specificDate.time.minutes > 59) {
                        this.validationErrors.dateTimeError = true;
                        return false;
                    }
                }
                if (!this.lesson.isFreeLesson && !this.lesson.price) {
                    this.validationErrors.priceError = true;
                    return false;
                }

                if (this.lesson.hasEquipments && !this.lesson.equipments) {
                    this.validationErrors.equipmentError = true;
                    return false;
                }
                return true;
            },
            dateFormatter(date) {
                return moment(date).format('DD/MM/YYYY');
            }
        }
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/course/StepFive.vue